'use client';

import { LogIn } from 'lucide-react';
import Link from 'next/link';
import { SiteShell } from '@/components/SiteShell';

export interface LoginRequiredProps {
  title: string;
  description: string;
}

/**
 * Bejelentkezés-kötelező oldalak üres-state-je. A `catalog-svc` /publications
 * és /collections végpontjai `TenantScope`-osak — token nélkül 401-et adnak,
 * ezért az ezeket fogyasztó oldalak guest-renderben ezt a komponenst mutatják
 * a 401-es backend-zaj helyett.
 */
export function LoginRequired({ title, description }: LoginRequiredProps) {
  return (
    <SiteShell>
      <div className="mx-auto max-w-2xl px-4 py-16 text-center sm:px-6">
        <LogIn className="mx-auto size-10 text-[var(--color-foreground-muted)]" />
        <h1 className="mt-4 font-display text-2xl font-bold">{title}</h1>
        <p className="mt-2 text-[var(--color-foreground-muted)]">{description}</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link
            href="/login"
            className="rounded-full bg-brand-600 px-6 py-2 text-sm font-semibold text-white hover:bg-brand-700"
          >
            Belépés
          </Link>
          <Link
            href="/signup"
            className="rounded-full border border-[var(--color-border)] px-6 py-2 text-sm font-semibold hover:bg-[var(--color-surface-subtle)]"
          >
            Regisztráció
          </Link>
        </div>
      </div>
    </SiteShell>
  );
}
